<template>
  <div class="main-content">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-auto">
          <h2 class="header-title">План</h2>
        </div>
        <div class="col-auto ml-auto">
          <button
            class="btn btn-primary"
            style="white-space: nowrap"
            @click="addModalShow"
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <div class="card-body">
        <template v-if="planList.length">
          <div class="row align-items-center">
            <div class="col-auto mb-2" v-if="newSearchList.length">
              <PerPageLenth
                class="mr-3"
                :page="page"
                :perPage="perPage"
                :allDataLenth="newSearchList.length"
              />
              <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
            </div>
            <div class="col-auto ml-auto mb-2">
              <div class="row">
                <div class="col-auto">
                  <div class="input-affix">
                    <i class="prefix-icon anticon anticon-search"></i>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="searchText"
                      placeholder="Поиск"
                    />
                  </div>
                </div>
                <div class="col-auto">
                  <button
                    class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                    :disabled="!newSearchList.length"
                    :class="{ excelHide: !newSearchList.length }"
                    @click="downloadFile"
                  >
                    <i class="anticon anticon-file-excel"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-2" />
          <template v-if="newSearchList.length">
            <table
              class="table table-sm table-responsive-md table-striped table-hover"
            >
              <thead class="">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Факультет</th>
                  <th scope="col">Направления</th>
                  <th scope="col">Специальность</th>
                  <th scope="col">Тип обучения</th>
                  <th scope="col">Форма обучения</th>
                  <th scope="col">Кол.</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="planList.length">
                  <tr v-for="(item, index) in newDatalist" :key="item.id">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ item.facultyname.name_kg }}</td>
                    <td>{{ item.directionname.name_kg }}</td>
                    <td>{{ item.spesname.name_kg }}</td>
                    <td>{{ item.type_o_name.name }}</td>
                    <td>{{ item.f_o_name.name }}</td>
                    <td>{{ item.plan }}</td>
                    <td>
                      <button
                        class="btn btn-icon btn-sm btn-danger btn-tone"
                        @click="deleteModalShow(item)"
                      >
                        <i class="anticon anticon-delete"></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <hr />
          </template>
          <div v-else class="noTdData">Нет данных</div>
        </template>
        <template v-else >
          <div v-if="dataLoading" class="loadData"><i class="anticon anticon-loading"></i></div>
          <div v-else class="noTdData">Нет данных</div>          
        </template>
        
        <Pagination
          :total="newSearchList.length"
          :perPage="perPage"
          @activePage="currentPage"
        />
      </div>
    </div>

    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title> Добавить план </template>

      <template>
        <div class="form-group">
          <label for="select_1_1">Факультет <span>*</span></label>
          <select
            class="custom-select"
            id="select_1_1"
            v-model="fak.val"
            @change="fakSelect"
            :disabled="fak.disabled"
            required
          >
            <option value="0" selected disabled>-- выбрать факультет --</option>
            <template v-if="fak.items != null">
              <option v-for="item in fak.items" :key="item.id" :value="item.id">
                {{ item.name_kg }}
              </option>
            </template>
          </select>
        </div>
        <div class="form-group">
          <label for="select_1_11">Направления <span>*</span></label>
          <select
            class="custom-select"
            id="select_1_11"
            v-model="direction.val"
            @change="directionSelect"
            :disabled="fak.val == 0"
            required
          >
            <option value="0" selected disabled>
              -- выбрать направления --
            </option>
            <template v-if="direction.items != null">
              <option
                v-for="item in direction.items"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name_kg }}
              </option>
            </template>
          </select>
        </div>
        <div class="form-group">
          <label for="select_1_2">Специальность <span>*</span></label>
          <select
            class="custom-select"
            id="select_1_2"
            v-model="spec.val"
            @change="specSelect"
            :disabled="direction.val == 0"
            required
          >
            <option value="0" selected disabled>
              -- выбрать специальность --
            </option>
            <template v-if="spec.items != null">
              <option
                v-for="item in spec.items"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name_kg }}
              </option>
            </template>
          </select>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="select_1_4">Тип обучения<span>*</span></label>
              <select
                class="custom-select"
                id="select_1_4"
                v-model="type_o.val"
                @change="type_oSelect"
                :disabled="spec.val == 0"
                required
              >
                <option value="0" selected disabled>---</option>
                <template v-if="type_o.items != null">
                  <option
                    v-for="item in type_o.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="select_1_5">Форма обучения<span>*</span></label>
              <select
                class="custom-select"
                id="select_1_5"
                v-model="f_o.val"
                :disabled="type_o.val == 0"
                @change="f_oSelect"
                required
              >
                <option value="0" selected disabled>---</option>
                <template v-if="f_o.items != null">
                  <option
                    v-for="item in f_o.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="in_3_5">План</label>
          <input
            type="text"
            class="form-control"
            id="in_3_5"
            v-model="plan.val"
            :disabled="f_o.val == 0"
          />
        </div>
        <div class="form-group">
          <label for="in_3_5">Описание</label>
          <input
            type="text"
            class="form-control"
            id="in_3_5"
            v-model="plan_description.val"
            :disabled="f_o.val == 0"
          />
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="addModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click.prevent="sendPlan">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Удалить план </template>

      <template>
        <h5>Вы действительно хотите удалить?</h5>
        <template v-if="itemPlan">
          <p>{{ itemPlan.facultyname.name_kg }}</p>
          <p>{{ itemPlan.directionname.name_kg }}</p>
          <p>{{ itemPlan.spesname.name_kg }}</p>
          <td>
            {{ itemPlan.type_o_name.name }} -
            {{ itemPlan.f_o_name.name }} - {{ itemPlan.plan }}
          </td>
        </template>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="deletePlan"
        >
          Подтвердить
        </button>
      </template>
    </Modal>
  </div>
</template>
<script>
import xlsx from "json-as-xlsx";

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
import Modal from "@/components/others/Modal.vue";

export default {
  name: "Plan",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  data() {
    return {
      isAddModalShow: false,
      isDeleteModalShow: false,
      planList: [],
      fak: { disabled: true, items: null, val: 0 },
      direction: { disabled: true, items: null, val: 0 },
      spec: { disabled: true, items: null, val: 0 },
      type_o: { disabled: true, items: null, val: 0 },
      f_o: { disabled: true, items: null, val: 0 },
      plan: { disabled: true, val: "" },
      plan_description: { val: "" },
      itemPlan: {
        id: null,
        facultyname: {name_kg: ''},
        directionname: {name_kg: ''},
        spesname: {name_kg: ''},
        type_o_name: {name: ''},
        f_o_name: {name: ''},
        itemPlan: {name: ''},
      },
      page: 1,
      perPage: 10,
      searchText: "",
      dataLoading: false
    };
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.planList.filter((x) => x.facultyname.name_kg.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    downloadFile() {
      let data = [
        {
          sheet: "План",
          columns: [
            { label: "#", value: "id" },
            { label: "Факультет", value: "facultyname.name_kg" },
            { label: "Багыт", value: "directionname.name_kg" },
            { label: "Адистик", value: "spesname.name_kg" },
            { label: "Окуу тиби", value: "type_o_name.name" },
            { label: "Окуу формасы", value: "f_o_name.name" },
            { label: "Саны", value: "plan" },
          ],
          content: [...this.newSearchList],
        },
      ];
      let settings = {
        fileName: "План",
      };
      xlsx(data, settings);
    },
    addModalShow() {
      this.isAddModalShow = true;
      this.getFak();
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    deleteModalShow(item) {
      this.isDeleteModalShow = true;
      this.itemPlan = {...item}
      
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },

    async getFak() {
      try {
        const data = (await this.$api.plan.plan_faculty()).data;
        this.fak.items = data;
        this.fak.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getDirection() {
      try {
        const data = (
          await this.$api.plan.plan_direction({
            id_faculty: this.fak.val,
          })
        ).data;
        this.direction.items = data;
        this.direction.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpec() {
      try {
        const data = (
          await this.$api.plan.plan_speciality({
            id_direction: this.direction.val,
          })
        ).data;
        this.spec.items = data;
        this.spec.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getType_o() {
      try {
        const data = (
          await this.$api.plan.plan_type_o({
            id_spes: this.spec.val,
          })
        ).data;
        this.type_o.items = data;
        this.type_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getF_o() {
      try {
        const data = (
          await this.$api.plan.plan_f_o({
            id_spes: this.spec.val,
            id_type_o: this.type_o.val,
          })
        ).data;
        this.f_o.items = data;
        this.f_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async get_plan() {
      this.dataLoading = true
      try {
        const data = (await this.$api.plan.get_plan()).data;
        this.planList = data;
        this.dataLoading = false
      } catch (error) {
        console.log(error);
      }
    },
    async add_plan() {
      try {
        await this.$api.plan.add_plan({
          id_faculty: this.fak.val,
          id_direction: this.direction.val,
          id_spes: this.spec.val,
          id_type_o: this.type_o.val,
          id_f_o: this.f_o.val,
          plan: this.plan.val,
          note: this.plan_description.val,
        });
        this.$nt("Успешно сохранен", "success");
        // this.addModalClose();
        this.get_plan();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранений", "dagner");
      }
    },
    
    async delete_plan() {
      try {
        await this.$api.plan.delete_plan({ id: this.itemPlan.id });
        this.$nt("Успешно удален", "success");
        this.deleteModalClose();
        this.get_plan();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка удаления", "dagner");
      }
    },
    sendPlan() {
      this.add_plan();      
    },
    deletePlan() {
      this.delete_plan();      
    },
    fakSelect() {
      this.direction.val = 0;
      this.spec.val = 0;
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.getDirection();
    },
    directionSelect() {
      this.spec.val = 0;
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.getSpec();
    },
    specSelect() {
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.getType_o();
    },
    type_oSelect() {
      this.f_o.val = 0;
      this.getF_o();
    },
    f_oSelect() {
      console.log("wer");
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.get_plan();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
</style>
